import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const TOPMATE_URL = 'https://topmate.io/acharya_ji_ajay_l_agrawal/2021138?utm_source=public_profile&utm_campaign=acharya_ji_ajay_l_agrawal';

const items = [
  { icon: 'Eye', text: 'Clear perspective on the situation you are facing' },
  { icon: 'Clock', text: 'Timing insight based on your current astrological phase' },
  { icon: 'Compass', text: 'Practical remedies if relevant to your situation' },
  { icon: 'Sunrise', text: 'A calmer understanding of the path ahead' },
];

export default function WhatYouLeaveWith() {
  return (
    <section className="py-24 px-6 md:px-12 bg-white border-y border-stone-200">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9 }}
          >
            <p className="text-brand-gold text-sm uppercase tracking-[0.3em] font-bold mb-5">After the Session</p>
            <h2 className="text-4xl md:text-5xl font-serif text-brand-dark mb-12 leading-tight">
              What You Leave With <br />
              <span className="italic text-brand-gold">After the Consultation</span>
            </h2>
            <ul className="space-y-8">
              {items.map((item, i) => (
                <motion.li
                  key={i}
                  initial={{ opacity: 0, x: -10 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.1, duration: 0.7 }}
                  className="flex items-start gap-6"
                >
                  <div className="w-14 h-14 rounded-full bg-brand-accent border border-brand-gold/30 flex items-center justify-center flex-shrink-0 shadow-sm">
                    <SafeIcon name={item.icon} className="text-brand-dark text-2xl" />
                  </div>
                  <span className="text-stone-700 font-medium text-xl leading-relaxed pt-3">{item.text}</span>
                </motion.li>
              ))}
            </ul>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2, duration: 0.9 }}
            className="space-y-8"
          >
            <div className="bg-brand-dark rounded-sm p-10 shadow-xl">
              <p className="text-brand-gold text-sm uppercase tracking-widest font-bold mb-8">A Note on Approach</p>
              <div className="space-y-6">
                {['No rushed predictions.', 'No unnecessary remedies.', 'Just grounded guidance.'].map((line, i) => (
                  <div key={i} className="flex items-center gap-5">
                    <span className="w-2 h-2 rounded-full bg-brand-gold flex-shrink-0"></span>
                    <p className="text-white font-serif text-2xl italic">{line}</p>
                  </div>
                ))}
              </div>
            </div>
            <div className="bg-brand-accent border border-brand-gold/20 rounded-sm p-10 shadow-md">
              <p className="font-serif text-brand-dark text-2xl leading-relaxed italic mb-6">
                "Clarity reduces pressure. Stability improves decisions."
              </p>
              <p className="text-stone-700 font-medium text-lg leading-relaxed mb-8">
                If you are at an important decision point, a conversation with Acharyaji is designed to leave you with more clarity than you arrived with. Not more confusion.
              </p>
              <a
                href={TOPMATE_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-3 px-10 py-5 bg-brand-dark text-brand-light hover:bg-brand-gold transition-all duration-400 rounded-sm font-bold tracking-wide text-lg w-full justify-center md:w-auto"
              >
                Book Consultation
                <SafeIcon name="ArrowRight" className="text-xl" />
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}